(function () {
  function scrollCarouselToIndex(carousel, indexPx, behavior) {
    if (!carousel) return;
    var w = carousel.clientWidth;
    if (w <= 0) return;
    carousel.scrollTo({ left: indexPx * w, behavior: behavior || 'auto' });
  }

  /** Before DOM ready — variant picker can jump gallery */
  function vetroGalleryGoToFallback(index) {
    var root = document.getElementById('vetro-product-hero');
    var idx = typeof index === 'number' && !Number.isNaN(index) ? Math.floor(index) : 0;
    var dataEl = document.getElementById('vetro-product-gallery-data');
    var urls = [];
    if (dataEl) {
      try {
        urls = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        urls = [];
      }
    }
    if (!Array.isArray(urls) || urls.length === 0) return;
    if (idx < 0) idx = 0;
    if (idx >= urls.length) idx = urls.length - 1;
    var carousel = root && root.querySelector('[data-vetro-main-carousel]');
    var mainImg = document.getElementById('mainImg');
    if (carousel) {
      scrollCarouselToIndex(carousel, idx, 'auto');
      if (carousel.clientWidth <= 0 && mainImg && urls[idx]) {
        mainImg.src = urls[idx];
      }
    } else if (mainImg && urls[idx]) {
      mainImg.src = urls[idx];
    }
    if (root) {
      root.querySelectorAll('[data-vetro-thumb]').forEach(function (t) {
        var i = Number(t.getAttribute('data-index'));
        var on = i === idx;
        t.classList.toggle('active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
  }

  window.vetroProductGalleryGoTo = vetroGalleryGoToFallback;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    var root = document.getElementById('vetro-product-hero');
    var dataEl = document.getElementById('vetro-product-gallery-data');
    var viewer = document.getElementById('vetroProductLightbox');
    var rail = document.getElementById('vetroFsRail');

    if (!root || !viewer || !rail) return;

    var slides = rail.querySelectorAll('.vetro-fs-viewer__slide');
    var n = slides.length;
    if (n === 0) return;

    var urls = [];
    if (dataEl) {
      try {
        urls = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        urls = [];
      }
    }
    if (!Array.isArray(urls)) urls = [];

    var carousel = root.querySelector('[data-vetro-main-carousel]');
    var thumbs = root.querySelectorAll('[data-vetro-thumb]');
    var mainImg = document.getElementById('mainImg');
    var currentIndex = 0;
    var scrollEndTimer;
    var railEndTimer;

    function syncThumbs() {
      thumbs.forEach(function (t) {
        var idx = Number(t.getAttribute('data-index'));
        var on = idx === currentIndex;
        t.classList.toggle('active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function clampIndex(i) {
      if (i < 0) i = 0;
      if (i >= n) i = n - 1;
      return i;
    }

    function wrap(i) {
      return ((i % n) + n) % n;
    }

    function scrollMainTo(i, smooth) {
      i = wrap(i);
      var behavior = smooth === true ? 'smooth' : 'auto';
      if (carousel) {
        scrollCarouselToIndex(carousel, i, behavior);
        if (carousel.clientWidth <= 0) {
          requestAnimationFrame(function () {
            scrollCarouselToIndex(carousel, i, behavior);
            if (carousel.clientWidth <= 0 && mainImg && urls[i]) {
              mainImg.src = urls[i];
            }
            currentIndex = i;
            syncThumbs();
          });
        } else {
          currentIndex = i;
          syncThumbs();
        }
        return;
      }
      if (mainImg && urls[i]) {
        mainImg.src = urls[i];
      }
      currentIndex = i;
      syncThumbs();
    }

    /** After finger lifts: align to nearest slide so you never sit “between” two images. */
    function readIndexFromCarousel() {
      if (!carousel || !viewer.hasAttribute('hidden')) return;
      var w = carousel.clientWidth;
      if (w <= 0) return;
      var i = clampIndex(Math.round(carousel.scrollLeft / w));
      var target = i * w;
      if (Math.abs(carousel.scrollLeft - target) > 3) {
        carousel.scrollTo({ left: target, behavior: 'auto' });
      }
      currentIndex = i;
      syncThumbs();
    }

    /** Fullscreen rail: same snap-to-nearest when scroll settles. */
    function readIndexFromRail() {
      var i = getRailIndexFromView();
      if (i < 0) return;
      currentIndex = i;
      syncThumbs();
    }

    function getRailIndexFromView() {
      if (!slides.length) return -1;
      var railRect = rail.getBoundingClientRect();
      var railCenter = railRect.left + railRect.width / 2;
      var bestIndex = 0;
      var bestDistance = Infinity;
      for (var s = 0; s < slides.length; s++) {
        var rect = slides[s].getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var distance = Math.abs(center - railCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = s;
        }
      }
      return bestIndex;
    }

    function scrollRailTo(i, behavior) {
      i = wrap(i);
      var slide = slides[i];
      if (slide && typeof slide.getBoundingClientRect === 'function') {
        var railRect = rail.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        var deltaLeft = slideRect.left - railRect.left;
        rail.scrollBy({ left: deltaLeft, behavior: behavior || 'auto' });
      } else {
        var w = rail.clientWidth;
        if (w > 0) rail.scrollTo({ left: i * w, behavior: behavior || 'auto' });
      }
      currentIndex = i;
      syncThumbs();
    }

    function snapRailTo(i) {
      i = wrap(i);
      var w = rail.clientWidth;
      if (w <= 0) return;
      scrollRailTo(i);
    }

    function openViewer(startIndex) {
      currentIndex = 0;
      viewer.removeAttribute('hidden');
      viewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vetro-product-lightbox-open');
      rail.focus({ preventScroll: true });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          snapRailTo(currentIndex);
          setTimeout(function () {
            scrollRailTo(currentIndex, 'auto');
          }, 60);
        });
      });
    }

    function closeViewer() {
      viewer.setAttribute('hidden', '');
      viewer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vetro-product-lightbox-open');
      if (carousel) {
        scrollMainTo(currentIndex, false);
      }
    }

    function goTo(i) {
      scrollMainTo(i, true);
      if (!viewer.hasAttribute('hidden')) {
        snapRailTo(i);
      }
    }

    function openLightboxFromZoomTarget(zoom) {
      openViewer(0);
    }

    if (carousel) {
      if ('onscrollend' in window) {
        carousel.addEventListener('scrollend', readIndexFromCarousel);
      } else {
        carousel.addEventListener(
          'scroll',
          function () {
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(readIndexFromCarousel, 120);
          },
          { passive: true }
        );
      }
    }

    if ('onscrollend' in window) {
      rail.addEventListener('scrollend', readIndexFromRail);
    } else {
      rail.addEventListener(
        'scroll',
        function () {
          clearTimeout(railEndTimer);
          railEndTimer = setTimeout(readIndexFromRail, 120);
        },
        { passive: true }
      );
    }

    window.addEventListener(
      'resize',
      function () {
        if (!viewer.hasAttribute('hidden')) {
          snapRailTo(currentIndex);
        } else if (carousel) {
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            scrollMainTo(currentIndex, false);
          }, 100);
        }
      },
      { passive: true }
    );

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.getAttribute('data-index'));
        if (!Number.isNaN(idx)) goTo(idx);
      });
    });

    root.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-vetro-open-lightbox]');
      if (!zoom || !root.contains(zoom)) return;
      openLightboxFromZoomTarget(zoom);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var zoom = e.target.closest('[data-vetro-open-lightbox]');
      if (!zoom || !root.contains(zoom)) return;
      e.preventDefault();
      openLightboxFromZoomTarget(zoom);
    });

    root.querySelectorAll('[data-vetro-prev]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    });
    root.querySelectorAll('[data-vetro-next]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    });

    viewer.querySelectorAll('[data-vetro-fs-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeViewer();
      });
    });

    function fsScrollStep(dir) {
      scrollRailTo(currentIndex + dir, 'smooth');
    }

    viewer.querySelectorAll('[data-vetro-fs-prev]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        fsScrollStep(-1);
      });
    });
    viewer.querySelectorAll('[data-vetro-fs-next]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        fsScrollStep(1);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (viewer.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        closeViewer();
        return;
      }
      var w = rail.clientWidth;
      if (w <= 0) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        rail.scrollBy({ left: -w, behavior: 'auto' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        rail.scrollBy({ left: w, behavior: 'auto' });
      }
    });

    requestAnimationFrame(readIndexFromCarousel);

    window.vetroProductGalleryGoTo = function (index) {
      goTo(typeof index === 'number' && !Number.isNaN(index) ? index : 0);
    };
  });
})();
